import { useRouteChangeStatus } from "@/hooks";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import styles from "@/styles/Video.module.scss";
import Image from "next/legacy/image";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PlayerThumbnail(_ref) {
  var _watch$episode;
  let {
    poster,
    watch,
    mediaLoaded,
    state
  } = _ref;
  const {
    isRouting
  } = useRouteChangeStatus();
  const channelId = Number(watch === null || watch === void 0 || (_watch$episode = watch.episode) === null || _watch$episode === void 0 || (_watch$episode = _watch$episode.channel) === null || _watch$episode === void 0 ? void 0 : _watch$episode.id);
  const showValuePlanLabel = (() => {
    if (!channelId) {
      return false;
    }
    return isShowValuePlanLabel({
      channelId
    }) && (!mediaLoaded && !isRouting || (state === null || state === void 0 ? void 0 : state.overlay) && (state === null || state === void 0 ? void 0 : state.reason) !== "next_episode");
  })();
  const showThumbnail = poster && !mediaLoaded && !(state !== null && state !== void 0 && state.overlay) && !isRouting;
  return /*#__PURE__*/_jsxs("div", {
    children: [showThumbnail && !!poster && /*#__PURE__*/_jsx(Image, {
      src: poster,
      alt: "thumbnail",
      layout: "fill",
      objectFit: "contain"
    }), showValuePlanLabel && false && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.valueplanLabel,
        children: /*#__PURE__*/_jsx(Image, {
          src: "/images/valueplan_label.png",
          alt: "valueplan_label",
          layout: "responsive",
          width: 1000,
          height: 247
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.leminoLogo,
        children: /*#__PURE__*/_jsx(Image, {
          src: "/images/lemino_logo.png",
          alt: "lemino_logo",
          layout: "fill",
          objectFit: "contain"
        })
      })]
    })]
  });
}